<script lang="ts">
  import Button from '../lib/ui/Button.svelte';
  import Drawer from '../lib/ui/Drawer.svelte';
  import Notice from '../lib/ui/Notice.svelte';
  import ContactPicker from './ContactPicker.svelte';
  import { ContactSearch } from '../lib/contact-search.svelte';
  import type { HeadquartersContact } from '../lib/api';
  import type { ReportLineDraft } from '../lib/report-line-draft.svelte';

  interface Props {
    eyebrow: string;
    draft: ReportLineDraft;
    error: string | null;
    onError: (err: unknown) => void;
    onClose: () => void;
  }

  let { eyebrow, draft, error, onError, onClose }: Props = $props();

  const search = new ContactSearch((err) => onError(err));
  search.watch();
  let chosen = $state<HeadquartersContact | null>(null);

  function add(): void {
    if (!chosen) return;
    draft.add(chosen);
    onClose();
  }
</script>

<Drawer {eyebrow} title="Adicionar contato" {onClose}>
  {#if error}
    <Notice tone="danger">{error}</Notice>
  {/if}
  <ContactPicker {search} {chosen} onChoose={(contact) => (chosen = contact)} isListed={(contact) => draft.isListed(contact)} />
  {#snippet footer()}
    <Button onclick={onClose}>Cancelar</Button>
    <Button variant="primary" disabled={!chosen} onclick={add}>Adicionar</Button>
  {/snippet}
</Drawer>
